import { useState } from 'react';
import { BillingCycle } from '../../../type';

interface UseBillingPlanSliceArgs {
    defaultCycle?: BillingCycle;
}

export const useBillingCycleSlice = ({ defaultCycle = BillingCycle.YEARLY }: UseBillingPlanSliceArgs = {}) => {
    const [currentCycle, setCurrentCycle] = useState<BillingCycle>(defaultCycle);

    const handleChangeBillingCycle = (selectedCycle: BillingCycle) => {
        setCurrentCycle(selectedCycle);
    };

    return {
        billingCycle: currentCycle,
        onChangeBillingCycle: handleChangeBillingCycle,
    };
};
